const SITE = 'https://learnwebcare.com';
export const LOGO_URL = `${SITE}/logo.webp`;

const organization = {
  '@type': 'Organization',
  '@id': `${SITE}/#organization`,
  name: 'LearnWebCare',
  url: `${SITE}/`,
  logo: {
    '@type': 'ImageObject',
    '@id': `${SITE}/#logo`,
    url: LOGO_URL,
    contentUrl: LOGO_URL,
    width: 928,
    height: 176,
  },
};

const website = {
  '@type': 'WebSite',
  '@id': `${SITE}/#website`,
  url: `${SITE}/`,
  name: 'LearnWebCare',
  publisher: {
    '@id': `${SITE}/#organization`,
  },
};

const customerCareService = {
  '@type': 'Service',
  '@id': `${SITE}/#customer-care-service`,
  name: 'LearnWebCare Customer Care Service',
  serviceType: 'Subscription customer care and cancellation service',
  description:
    'Online customer care service for managing subscriptions, accessing subscription information, contacting support agents, and cancelling subscriptions.',
  url: `${SITE}/`,
  provider: {
    '@id': `${SITE}/#organization`,
  },
};

export const homePageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE}/#webpage`,
  url: `${SITE}/`,
  name: 'Subscription Management & Billing Support | LearnWebCare',
  description:
    'Get support for subscription management, billing, account questions, and cancellation. LearnWebCare provides after-sales support through trained customer service agents.',
  isPartOf: website,
  about: customerCareService,
  publisher: organization,
};

const faqQuestions = [
  {
    '@type': 'Question',
    name: 'Why do I have a Learnwebcare charge on my bank statement?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'If a direct debit appears on your statement, you have probably signed up to a subscription to one of our partner sites for which we provide the after-sales service. Please note that you are not a client of Learnwebcare, but a client of a site that has delegated the management of its customer service.',
    },
  },
  {
    '@type': 'Question',
    name: 'What are the services offered by Learnwebcare?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Learnwebcare offers simplified management of your subscription. Fill in the form on the home page with an e-mail address used at the time of subscription. You will be able to contact the agents responsible for your file, obtain all the information concerning your subscription or cancel it.',
    },
  },
  {
    '@type': 'Question',
    name: 'What kind of subscription do you need for after-sales service?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Learnwebcare provides customer service subscriptions that make your life easier. We work with sites that offer help to individuals or professionals, accompanying the client during various operations or steps.',
    },
  },
  {
    '@type': 'Question',
    name: 'I do not remember signing up to a Learnwebcare subscription.',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'You have not signed up to a Learnwebcare subscription. You have definitely signed up to a subscription at one of our partner sites for which we provide after-sales service.',
    },
  },
  {
    '@type': 'Question',
    name: 'How to find the offer to which I subscribed?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Fill in the form on the home page with the email address used when registering. We will provide you with important information about your subscription, such as the date and amount of the next withdrawal and the service features you have selected.',
    },
  },
  {
    '@type': 'Question',
    name: 'I forgot the email address used when subscribing. What can I do?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'If you are unable to retrieve the email address used during the subscription, our agents always have the possibility to find your client file. Contact our agents by email or chat.',
    },
  },
  {
    '@type': 'Question',
    name: 'Who can I contact if I have a question?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Our agents are experts in after-sales service and are available 24/7. Contact them by live chat or by phone via our toll-free number any time you need. You can also send them a message.',
    },
  },
  {
    '@type': 'Question',
    name: 'How can I cancel my subscription?',
    acceptedAnswer: {
      '@type': 'Answer',
      text: 'Go to your customer account and click the Cancel button. You will no longer benefit from the services of our partner site and will no longer be charged. A confirmation email will be sent.',
    },
  },
];

export const faqPageSchema = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  '@id': `${SITE}/faq/#webpage`,
  url: `${SITE}/faq/`,
  name: 'FAQ | LearnWebCare',
  description:
    'Find answers to common questions about LearnWebCare charges, subscriptions, customer support, subscription details, and cancellation.',
  isPartOf: website,
  about: customerCareService,
  publisher: organization,
  mainEntity: {
    '@type': 'FAQPage',
    '@id': `${SITE}/faq/#faqpage`,
    url: `${SITE}/faq/`,
    mainEntity: faqQuestions,
  },
};
